/**
 * Obj property getter. Can get deep property
 * ex: get(obj, "foo.bar")
 */
export const get = (obj:any, path:string) => {
    return path.split(".").reduce((prev, curr) => {
        return prev ? prev[curr] : undefined;
    }, obj);
};

/**
 * Obj property setter. Can set deep property
 * ex: set(obj, "foo.bar", "baz")
 */
export const set = (obj, path, value) => {

  let schema = obj;
  let pList = path.split(".");
  let len = pList.length;

  for (let i = 0; i < len - 1; i++) {
    let elem = pList[i];
    if (!schema[elem]) schema[elem] = {};
    schema = schema[elem];
  }

  schema[pList[len - 1]] = value;
};

export function filterObject(body, predicate) {
  let output = {};
  for( let key of Object.keys(body)){
    if( predicate(key, body[key], body)){
      output[key] = body[key];
    }
  }
  return output;
}